
import ImgOne from '../assets/images/our-services/organic-food.webp'
import ImgTwo from '../assets/images/our-services/express-delivery.webp'
import ImgThree from '../assets/images/our-services/unforgable-taste.webp'

const ourServices = [
    {
        id: 1,
        img: ImgOne,
        name: 'Organic Food',
        description:
            'Pure and healthy organic food is our lifestyle. The products we consume has impact on out future and we do everything to keep the future healthy',
    },
    {
        id: 2,
        img: ImgTwo,
        name: 'Express Delivery',
        description:
            'Choose from a variety of express delivery services depending on your needs. Whether in a hurry to eat or have some plans tomorrow, we have got you covered',
    },
    {
        id: 3,
        img: ImgThree,
        name: 'Unforgettable Taste',
        description:
            'Our goal is to provide our customers with excellent service, great taste and unforgettable experiences. This will be a mind-blowing experience for your taste buds',
    },
]

export default ourServices;